import { Routes } from '@angular/router';
import { authGuard } from "../../_shared/helpers";
import { ProjectsComponent } from "./projects/projects.component";
import { ProjectDetailsComponent } from "./project-details/project-details.component";
import {
    ProjectDetailsStammdatenComponent
} from "./project-details/project-details-stammdaten/project-details-stammdaten.component";
import {
    ProjectDetailsDocumentsComponent
} from "./project-details/project-details-documents/project-details-documents.component";
import {
    ProjectDetailsInvoicesComponent
} from "./project-details/project-details-invoices/project-details-invoices.component";
import {ProjectDetailsOfferComponent} from "./project-details/project-details-offer/project-details-offer.component";
import {ProjectDetailsOrderComponent} from "./project-details/project-details-order/project-details-order.component";
import {
    ProjectDetailsRequestsComponent
} from "./project-details/project-details-requests/project-details-requests.component";
import {
    ProjectDetailsPositionsComponent
} from "./project-details/project-details-positions/project-details-positions.component";
import {ProjectUpdateComponent} from "./project-update/project-update.component";
import {ProjectAddComponent} from "./project-add/project-add.component";


export const PROJECT_ROUTES: Routes = [
    {
        path: 'projects',
        pathMatch: 'full',
        redirectTo: 'projects/overview',
    },
    {
        path: 'projects/overview',
        component: ProjectsComponent,
        canActivate: [authGuard]
    },
    {
        path: 'project/details/:cid/:prid',
        component: ProjectDetailsComponent,
        children: [
            {
                path: 'stammdaten',
                component: ProjectDetailsStammdatenComponent,
                canActivate: [authGuard]
            },
            {
                path: 'positionen',
                component: ProjectDetailsPositionsComponent,
                canActivate: [authGuard]
            },
            /*{
                path: 'technology',
                component: ProjectDetailsTechnologyComponent,
                canActivate: [authGuard]
            },*/
            {
                path: 'requests',
                component: ProjectDetailsRequestsComponent,
                canActivate: [authGuard]
            },
            {
                path: 'orders',
                component: ProjectDetailsOrderComponent,
                canActivate: [authGuard]
            },
            {
                path: 'offers',
                component: ProjectDetailsOfferComponent,
                canActivate: [authGuard]
            },
            {
                path: 'invoices',
                component: ProjectDetailsInvoicesComponent,
                canActivate: [authGuard]
            },
            {
                path: 'documents',
                component: ProjectDetailsDocumentsComponent,
                canActivate: [authGuard]
            }
        ],
        canActivate: [authGuard],
        runGuardsAndResolvers: 'always'
    },
    {
        path: 'project/update/:cid/:prid',
        component: ProjectUpdateComponent,
        canActivate: [authGuard]
    },
    {
        path: 'project/add/:cid/:pid',
        component: ProjectAddComponent,
        canActivate: [authGuard]
    }
];
